import {createStyles} from '@mantine/core';
import React from 'react';

import RedesignSidebarActions from './RedesignSidebarActions';

const useStyles = createStyles(() => ({
  toolbar: {
    height: 22,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 4,
  },
}));

/**
 * Top-right controls of the redesigned sidebar (wide view). The buttons themselves live in the shared
 * {@link RedesignSidebarActions} so the wide sidebar and the semi-expanded header stay in sync. The
 * sidebar toggle (hamburger) is a separate floating control rendered by the sidepanel.
 */
export default function RedesignSidebarToolbar(): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.toolbar}>
      <RedesignSidebarActions />
    </div>
  );
}
